var exports = {
  "k": "x61f99309--2b0204--container",
  "g": "x61f99309--2b0204--menu_item",
};

module.exports = exports;
